<header class="banner" role="banner" [class.important]="important" [class.info]="info" [class.error]="error">

  <div class="header">
    <div class="toolbar">
      <div style="flex-grow: 1"></div>
      <ng-content select=".toolbar-content"></ng-content>
    </div>
    <div style="flex-grow: 1; order: 1"></div>
    @if (!dynamicHeading) {
      <div class="title">
        <div class="title-content">
          <h1 class="sm-show">{{heading}}</h1>
          <p class="intro-text">{{subHeading}}</p>
        </div>
        <ng-content select=".title-content"></ng-content>
      </div>
    }
    @if (dynamicHeading) {
      <app-collapsible [trigger]="!loading">
        <div class="title">
          <div class="title-content">
            <h1 class="sm-show">{{heading}}</h1>
            <p class="intro-text">{{subHeading}}</p>
          </div>
          <ng-content select=".title-content"></ng-content>
        </div>
      </app-collapsible>
    }
  </div>

</header>

@if (loading || updating) {
  <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
}